Bootstrap = require 'react-bootstrap'
Flash = require '../components/Flash'
Footer = require '../containers/Footer'
Header = require '../containers/Header'
React = require 'react'
require '../../styles/App'
require 'bootstrap/dist/css/bootstrap.min.css'
require 'react-redux-toastr/src/less/react-redux-toastr.less'
Sidebar = require '../components/Sidebar';
{ checkToken } = require '../actions/auth'
{ clearFlash } = require '../actions/flash'
{ Component, PropTypes } = React
{ connect } = require 'react-redux'

# These are debug helpers.
global.v = (args...) ->
  args.unshift '-----------------------------'
  console.log.apply null, args

global.vj = (str, obj) ->
  if obj
    v str, JSON.stringify(obj, null, 2)
    return
  v JSON.stringify(str, null, 2)

App = React.createClass
	displayName: 'App'
	propTypes:
		clearFlash: PropTypes.func.isRequired
		currentObservation: PropTypes.object
		flash: PropTypes.object,
		isAuthenticated: PropTypes.bool

	contextTypes:
		router: PropTypes.object

	childContextTypes:
		user: PropTypes.object

	componentWillMount: ->
		# If the frontend believes a user is already logged in, check their JWT
		if @props.user && @props.location.pathname != '/logout'
			@props.checkToken()

	getChildContext: ->
		user: @props.user

	shouldShowHeader: ->
		!@props.location.pathname.match(/\/observations\/\d+$/) && !@props.location.pathname.match(/\/observations\/current/)

	shouldShowNavigation: ->
		# Always hide the navigation if the user is not logged in
		if !this.props.user
			return false

		currentPath = this.props.location.pathname
		pathsToHideNavigation = [/\/observations\/\d+$/, /\/observations\/current/]
		shouldShowNavigation = true

		pathsToHideNavigation.map (path) =>
			if (currentPath.match(path))
				shouldShowNavigation = false

		return shouldShowNavigation

	shouldShowFooter: ->
		!@props.location.pathname.match(/\/observations\/\d+$/) && !@props.location.pathname.match(/\/observations\/current/)

	render: ->
		{ children, clearFlash, flash } = @props

		React.createElement("div", {"className": "app"},
			React.createElement("div", {"className": "container-fluid app-container"},
				(
					if @shouldShowHeader()
						React.createElement(Header, { \
							"isAuthenticated": ( this.props.isAuthenticated ),  \
							"shouldShowHamburger": ( this.shouldShowNavigation() ),  \
							"user": ( this.props.user )
						})
				),
				(
					if @shouldShowNavigation()
						React.createElement("div", {"className": "main has-navigation"},
							React.createElement(Sidebar, { \
								"currentObservation": ( this.props.currentObservation ),  \
								"currentPath": ( this.props.location.pathname ),  \
								"user": ( this.props.user )
							}),
							React.createElement("div", {"className": "content-container"},
								React.createElement("div", {"className": "content"},
									( children )
								),
								( if @shouldShowFooter() then React.createElement(Footer, null) else '' )
							)
						)
					else
						React.createElement("div", {"className": "main"},
							( children ),
							( if @shouldShowFooter() then React.createElement(Footer, null) else '' )
						)
				)
			),
			React.createElement(Flash, {"flash": ( flash ), "clearFlash": ( clearFlash )})
		)

mapStateToProps = (state) ->
	currentObservation: state.observations.current
	flash: state.flash
	isAuthenticated: state.auth.isAuthenticated
	user: state.auth.user

mapDispatchToProps = {
	checkToken,
	clearFlash
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(App)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/containers/App.cjsx